// extracted by mini-css-extract-plugin
export default {"label":"checkbox_label__VhWRt","checkboxContainer":"checkbox_checkboxContainer__Euq8z","icon":"checkbox_icon__d+c3k","input":"checkbox_input__b2Hmp"};